module.exports = __webpack_public_path__ + "static/anu-e5b9110a75d4503d4a2662b109308edb.jpeg";